import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-24f5e56e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_CategoryMultiSelect = _resolveComponent("CategoryMultiSelect")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ExpenseForm = _resolveComponent("ExpenseForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.items,
      rows: 20,
      class: "p-datatable-gridlines p-datatable-sm",
      dataKey: "id",
      rowHover: false,
      filters: _ctx.filters,
      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters) = $event)),
      onFilter: _ctx.onFilter,
      filterDisplay: "menu",
      loading: _ctx.loading || _ctx.loadingRemove,
      responsiveLayout: "scroll",
      globalFilterFields: ['amount', 'motif', 'category.label'],
      "sort-order": 0,
      "rows-per-page-options": [20, 30, 40, 50]
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Button, {
          type: "button",
          icon: "pi pi-filter-slash",
          label: _ctx.$t('clear'),
          class: "p-button-outlined p-mb-1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilter()))
        }, null, 8, ["label"]),
        _createElementVNode("span", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_InputText, {
            modelValue: _ctx.filters.global.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.global.value) = $event)),
            placeholder: _ctx.$t('search'),
            style: {"width":"100%"},
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('search', _ctx.filters.global.value)), ["enter"]))
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        (!_ctx.expired)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-plus",
              label: _ctx.$t('add'),
              class: "p-button-outlined",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDialog(null))),
              disabled: !_ctx.sequenceId && _ctx.$route.name === 'pos'
            }, null, 8, ["label", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("expense.none")), 1)
      ]),
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("loading")), 1)
      ]),
      footer: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: _ctx.$t('createdAt'),
          dataType: "date",
          field: "createdAt",
          style: {"min-width":"10rem"},
          sortable: true,
          "show-add-button": false,
          showFilterOperator: false,
          "show-apply-button": false
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_Calendar, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              dateFormat: _ctx.$t('format.calendarDate'),
              placeholder: _ctx.$t('format.date'),
              "year-navigator": true,
              onDateSelect: ($event: any) => (filterCallback())
            }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder", "onDateSelect"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('prime.clear'),
              onClick: ($event: any) => (filterCallback()),
              style: {"width":"100%"}
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('expense.motif'),
          field: "motif",
          style: {"min-width":"10rem"},
          "show-add-button": false,
          showFilterOperator: false,
          "show-apply-button": false,
          sortable: true,
          "sort-field": "motif",
          "filter-field": "motif"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": [($event: any) => ((filterModel.value) = $event), ($event: any) => (filterCallback())],
              class: "p-column-filter",
              placeholder: _ctx.$t('expense.filterByMotif')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('prime.clear'),
              onClick: ($event: any) => (filterCallback()),
              style: {"width":"100%"}
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          showFilterMatchModes: false,
          "show-add-button": false,
          showFilterOperator: false,
          field: "category.label",
          sortable: true,
          "filter-field": "category.id",
          header: _ctx.$t('product.category'),
          "show-apply-button": false
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_CategoryMultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": [($event: any) => ((filterModel.value) = $event), ($event: any) => (filterCallback())],
              items: _ctx.categories,
              style: {"max-width":"220px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('prime.clear'),
              onClick: ($event: any) => (filterCallback()),
              style: {"width":"100%"}
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('expense.amount'),
          field: "amount",
          "filter-field": "amount",
          style: {"min-width":"10rem"},
          "sort-field": "amount",
          sortable: true,
          "show-add-button": false,
          showFilterOperator: false,
          "show-apply-button": false,
          dataType: "numeric"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_NumberFormatter, {
              value: data.amount
            }, null, 8, ["value"]),
            _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputNumber, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              mode: "decimal",
              locale: _ctx.numberSeparators[_ctx.activeActivity.separator],
              "max-fraction-digits": 20,
              onInput: ($event: any) => (filterCallback())
            }, null, 8, ["modelValue", "onUpdate:modelValue", "locale", "onInput"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('prime.clear'),
              onClick: ($event: any) => (filterCallback()),
              style: {"width":"100%"}
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"width":"10%","min-width":"8rem"},
          bodyStyle: "text-align:center",
          header: _ctx.$t('controls')
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_BlockUI, {
              blocked: !!_ctx.expired
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  style: {"width":"20px","height":"20px"},
                  icon: "pi pi-pencil",
                  class: "p-button-danger p-button-text p-button-rounded p-mr-3",
                  onClick: ($event: any) => (_ctx.openDialog(data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  style: {"width":"20px","height":"20px"},
                  icon: "pi pi-trash",
                  class: "p-button-danger p-button-text p-button-rounded",
                  onClick: ($event: any) => (_ctx.submitRemove($event, data.id))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["blocked"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_ColumnGroup, { type: "footer" }, {
          default: _withCtx(() => [
            _createVNode(_component_Row, null, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  footer: _ctx.$t('payment.total'),
                  colspan: 3
                }, null, 8, ["footer"]),
                _createVNode(_component_Column, {
                  colspan: 2,
                  footer: `${_ctx.formatNumber(_ctx.filteredTotal)} ${
            _ctx.activeActivity.currencySymbol
          }`
                }, null, 8, ["footer"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["value", "filters", "onFilter", "loading"]),
    (_ctx.dialog.visible)
      ? (_openBlock(), _createBlock(_component_ExpenseForm, {
          key: 0,
          visible: _ctx.dialog.visible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog.visible) = $event)),
          expense: _ctx.dialog.expense,
          "sequence-id": _ctx.sequenceId,
          categories: _ctx.categories
        }, null, 8, ["visible", "expense", "sequence-id", "categories"]))
      : _createCommentVNode("", true)
  ], 64))
}